import { z } from 'zod';

/**
 * Which surface a question section is rendered on (owner decision 2026-07-22).
 *
 * The flow is the reason registration is not hardcoded: only email, password,
 * gender, dob and locale are structural (they are what an account *is*), and
 * everything else a registrant is asked — country, civil registry id, anything
 * a future market needs — is a `registration` section staff can reorder, retitle
 * or retire without a deploy (A4).
 *
 * `profile_wizard` sections render after signup, in the wizard that fills out a
 * member's profile. The split matters beyond ordering: registration questions
 * gate `registered → profile_incomplete`, wizard questions gate
 * `profile_incomplete → pending_verification`, so a question moved between
 * flows moves the lifecycle boundary with it.
 */
export const QUESTION_FLOWS = ['registration', 'profile_wizard'] as const;

export const QuestionFlowSchema = z.enum(QUESTION_FLOWS);

export type QuestionFlow = (typeof QUESTION_FLOWS)[number];

const FLOW_SET: ReadonlySet<string> = new Set<string>(QUESTION_FLOWS);

/** Narrows a plain string — what a route parameter passes through. */
export function isQuestionFlow(value: string): value is QuestionFlow {
  return FLOW_SET.has(value);
}
